import { render } from "./NavigationLayout.vue?vue&type=template&id=31fc4134&scoped=true"
import script from "./NavigationLayout.vue?vue&type=script&lang=js"
export * from "./NavigationLayout.vue?vue&type=script&lang=js"

import "./NavigationLayout.vue?vue&type=style&index=0&id=31fc4134&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fc4134"]])

export default __exports__